<template>
  <nav
    :style="{
      backgroundImage:
        'linear-gradient( 96.5deg,  rgba(39,103,187,' +
        opacity +
        ') 10.4%, rgba(16,72,144,' +
        opacity +
        ') 87.7% )',
    }"
  >
    <h2 class="logo" style="margin-bottom: 0" @click="toHome">
      知识图谱与类脑智能实验室
    </h2>
    <div class="nav-menu">
      <div class="nav-item" @click="toHome">HOME</div>
      <div class="nav-item sub-item-container" @click.self="toPeople">
        PEOPLE
        <div class="sub-items">
          <div class="sub-item" @click="toXxl">徐小良 Xiaoliang Xu</div>
          <div class="sub-item" @click="toWyx">王宇翔 Yuxiang Wang</div>
          <div class="sub-item" @click="toWmz">王梦召 Mengzhao Wang</div>
          <div class="sub-item" @click="toFqm">方启明 Qiming Fang</div>
          <div class="sub-item" @click="toXyx">夏一行 Yixing Xia</div>
          <div class="sub-item" @click="toWjm">王俊美 Junmei Wang</div>
          
          <div class="sub-item" @click="toXyx">王晶晶 Jingjing Wang</div>
        </div>
      </div>
      <div class="nav-item" @click="toResearch">RESEARCH</div>
      <div class="nav-item" @click="toPublication">PUBLICATION</div>
      <div class="nav-item" @click="toJoinus">JOINUS</div>
    </div>
    <div class="burger">
      <div class="top-line"></div>
      <div class="middle-line"></div>
      <div class="bottom-line"></div>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      opacity: 0,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.windowScroll);
    const burger = this.$el.querySelector(".burger");
    const navMenu = this.$el.querySelector(".nav-menu");
    const navMenuItems = this.$el.querySelectorAll(".nav-item");
    burger.addEventListener("click", () => {
      burger.classList.toggle("active");
      navMenu.classList.toggle("open");
      console.log(navMenuItems);
      navMenuItems.forEach((item, index) => {
        if (item.style.animation) {
          item.style.animation = "";
        } else {
          item.style.animation = `0.3s ease-in slideIn forwards ${
            index * 0.1 + 0.3
          }s`;
        }
      });
    });
    if (this.$router.currentRoute.name != "home") {
      this.opacity = 1;
    }
  },
  methods: {
    windowScroll() {
      if (this.$router.currentRoute.name != "home") {
        return;
      }
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop < 100 && scrollTop > 40) {
        this.opacity = 0.7 + (scrollTop - 40) * 0.005;
      } else if (scrollTop < 80) {
        this.opacity = 0;
      } else {
        this.opacity = 1;
      }
    },
    toHome() {
      this.opacity = 0;
      this.$router.push("/home");
    },
    toResearch() {
      this.opacity = 1;
      this.$router.push("/research");
    },
    toPeople() {
      this.opacity = 1;
      this.$router.push("/people");
    },
    toPublication() {
      this.opacity = 1;
      this.$router.push("/publication");
    },
    toJoinus() {
      this.opacity = 1;
      this.$router.push("/joinus");
    },
    toXxl() {
      this.opacity = 1;
      this.$router.push("/xuxiaoliang");
    },
    toWyx() {
      this.opacity = 1;
      // this.$router.push("/wangyuxiang");
      window.location.href = "https://wyxlss.github.io/";
    },
    toWmz() {
      this.opacity = 1;
      // this.$router.push("/wangyuxiang");
      window.location.href = "https://mzwang.top/";
    },
    toWjm() {
      window.location.href = "https://faculty.hdu.edu.cn/jsjxy/wjm/main.htm";
    },
    toXyx() {
      this.opacity = 1;
      this.$router.push("/xiayixing");
    },
    toFqm() {
      this.opacity = 1;
      this.$router.push("/fangqiming");
    },
  },
};
</script>

<style scoped>
nav {
  width: 100%;
  position: fixed;
  z-index: 999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5vw;
  height: 60px;
  line-height: 60px;
  background-image: linear-gradient(
    96.5deg,
    rgba(39, 103, 187, 0) 10.4%,
    rgba(16, 72, 144, 0) 87.7%
  );
}

.logo {
  /* color: #dadbdd; */
  color: white;
  font-weight: 500;
  font-size: 24px;
  flex: 1;
  text-shadow: 0px 1px 14px rgba(0, 0, 0, 1);
}
.logo:hover {
  cursor: pointer;
}
.nav-menu {
  display: flex;
  flex: 1;
  justify-content: space-between;
  max-width: 550px;
}
.sub-item-container {
  position: relative;
  display: inline-block;
}
.sub-items {
  display: none;
  position: absolute;
  background: white;
  min-width: 200px;
  text-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
}
.sub-item {
  color: #666;
  padding-left: 20px;
  font-weight: normal;
  font-size: 15px;
  border-bottom: 1px solid #ddd;
  height: 50px;
  line-height: 50px;
}
.sub-item-container:hover .sub-items {
  display: block;
}

.nav-item {
  list-style: none;
  color: white;
  font-weight: 600;
  font-size: 18px;
  text-shadow: 0px 1px 14px rgba(0, 0, 0, 1);
}
.nav-item:hover {
  cursor: pointer;
}

.burger {
  display: none;
}

.burger div {
  /* 设置汉堡按钮三层条 */
  width: 25px;
  height: 3px;
  background-color: #dadbdd;
  margin: 4px;
}

@media screen and (max-width: 900px) {
  .nav-menu {
    position: absolute;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    top: 80px;
    right: 0;
    bottom: 0;
    width: 50vw;
    margin: 0;
    height: calc(100vh - 80px);
    z-index: 997;
    background-color: rgba(65, 81, 101, 0.9);

    transform: translateX(100%);
  }
  .sub-item-container:hover .sub-items {
    display: none;
  }
  /* 单机汉堡按钮 控制菜单的出现 */
  .nav-menu.open {
    transform: translateX(0);
    /* background: red; */
    border-radius: 8px;
  }

  .nav-item {
    margin: 3vh;
    transform: translateX(20px);
    z-index: 997;
    /* opacity: 0; */
  }

  /* 汉堡按钮 */
  .burger {
    display: block;
  }

  .burger.active div {
    transition: 0.3s ease-in-out 0.3s;
  }

  /* 第一条线旋转45度 */
  .burger.active .top-line {
    transform: rotate(45deg) translate(4px, 6px);
  }

  /* 中间线向右移动并变为透明 */
  .burger.active .middle-line {
    opacity: 0;
    transform: translateX(10px);
    transition: 0.3s ease-in-out;
  }

  /* 第三条线旋转-45度 */
  .burger.active .bottom-line {
    transform: rotate(-45deg) translate(4px, -6px);
  }

  /* 菜单滑出动画 */
  @keyframes slideIn {
    from {
      transform: translateX(20px);
      opacity: 0;
    }

    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/head/index.vue